var map = {
	"./basketball.webp": 1532,
	"./bti-img.webp": 1533,
	"./bti-title-en.webp": 1534,
	"./cup.webp": 1535,
	"./football.webp": 1536,
	"./im-img.webp": 1537,
	"./im-title-en.webp": 1538,
	"./sb-img.webp": 1539,
	"./sb-title-cn.webp": 1540,
	"./sb-title-en.webp": 1541,
	"./sbo-img.webp": 1542,
	"./sbo-title-cn.webp": 1543,
	"./sbo-title-en.webp": 1544,
	"./sport-bg.webp": 1545,
	"./sport-ctg.webp": 1546,
	"./title-cn.webp": 1547,
	"./title-en.webp": 1548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 758;